const rup = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function InvoiceThermal({ order, biz }) {
  const items = order.items || [];
  return (
    <div className="sheet thermal" data-testid="invoice-thermal">
      <div style={{ textAlign: "center" }}>
        <div style={{ fontWeight: 800, fontSize: 15 }}>{biz.name}</div>
        {biz.address && <div>{biz.address}{biz.city ? `, ${biz.city}` : ""}</div>}
        {biz.phone && <div>Ph: {biz.phone}</div>}
        {biz.show_gst && biz.gstin && <div>GSTIN: {biz.gstin}</div>}
      </div>
      <hr />
      <div className="r"><span>Invoice: {order.invoice_no || order.order_no}</span></div>
      <div className="r"><span>{new Date(order.created_at).toLocaleString("en-IN")}</span></div>
      {order.customer_name && order.customer_name !== "Walk-in" && <div>Customer: {order.customer_name} {order.customer_phone ? `(${order.customer_phone})` : ""}</div>}
      <hr />
      <table><tbody>
        <tr style={{ fontWeight: 700 }}><td>Item</td><td style={{ textAlign: "center" }}>Qty</td><td style={{ textAlign: "right" }}>Amt</td></tr>
        {items.map((i, x) => (
          <tr key={`${i.product_id || i.name}-${x}`}><td>{i.name}{i.discount ? ` (-${rup(i.discount)})` : ""}</td><td style={{ textAlign: "center" }}>{i.quantity}×{rup(i.price)}</td><td style={{ textAlign: "right" }}>{rup(i.line_total)}</td></tr>
        ))}
      </tbody></table>
      <hr />
      <div className="r"><span>Subtotal</span><span>{rup(order.subtotal)}</span></div>
      {order.discount > 0 && <div className="r"><span>Discount</span><span>-{rup(order.discount)}</span></div>}
      <div className="r"><span>GST</span><span>{rup(order.gst)}</span></div>
      {order.extra_charge > 0 && <div className="r"><span>Charges</span><span>{rup(order.extra_charge)}</span></div>}
      {order.round_off !== 0 && <div className="r"><span>Round off</span><span>{rup(order.round_off)}</span></div>}
      <div className="r" style={{ fontWeight: 800, fontSize: 14 }}><span>TOTAL</span><span>{rup(order.total)}</span></div>
      <hr />
      {(order.payments || []).map((p, x) => <div className="r" key={`${p.method}-${x}`}><span style={{ textTransform: "capitalize" }}>{p.method}</span><span>{rup(p.amount)}</span></div>)}
      {order.change > 0 && <div className="r"><span>Change</span><span>{rup(order.change)}</span></div>}
      {order.credit_amount > 0 && <div className="r" style={{ fontWeight: 700 }}><span>Udhaar (due)</span><span>{rup(order.credit_amount)}</span></div>}
      <hr />
      <div style={{ textAlign: "center", marginTop: 4 }}>{biz.footer_note}</div>
    </div>
  );
}
